import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebase/firebase-config';
import { collection, addDoc, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Trash2, Upload, CheckCircle2, AlertCircle, HelpCircle, Megaphone } from 'lucide-react';

const AnnouncementManager = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [file, setFile] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [uploading, setUploading] = useState(false);

  // Bildirim ve Onay Durumları
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null });

  const showPopup = (message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
  };

  const fetchAnnouncements = async () => {
    try {
      const q = query(collection(db, "announcements"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      setAnnouncements(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error("Duyurular çekilemedi:", err);
    }
  };

  useEffect(() => { fetchAnnouncements(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!title || !content || !file) return showPopup("Lütfen tüm alanları ve görseli doldurunuz.", "error");

    setUploading(true);
    try {
      // 1. Görseli Firebase Storage'a yükle
      const storageRef = ref(storage, `announcements/${Date.now()}_${file.name}`);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);

      // 2. Verileri Firestore'a kaydet
      await addDoc(collection(db, "announcements"), {
        title,
        content,
        imageUrl,
        date: new Date().toLocaleDateString('tr-TR'),
        createdAt: new Date()
      });

      setTitle(''); 
      setContent(''); 
      setFile(null);
      fetchAnnouncements();
      showPopup("Duyuru başarıyla yayınlandı.", "success");
    } catch (err) {
      showPopup("Yayınlama sırasında bir hata oluştu.", "error");
    }
    setUploading(false);
  };

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "announcements", deleteModal.id));
      setDeleteModal({ show: false, id: null });
      fetchAnnouncements();
      showPopup("Duyuru silindi.", "success");
    } catch (err) {
      showPopup("Silme işlemi başarısız.", "error");
    }
  };

  return (
    <div className="slider-manager-container">
      {/* Bildirim Popup'ı */}
      {notification.show && (
        <div className={`notification-popup ${notification.type}`}>
          {notification.type === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
          <span>{notification.message}</span>
        </div>
      )}

      {/* Silme Onay Modalı */}
      {deleteModal.show && (
        <div className="confirm-modal-overlay">
          <div className="confirm-modal">
            <HelpCircle size={45} color="#d4a373" />
            <h3>Duyuruyu Sil</h3>
            <p>Bu duyuruyu kaldırmak istediğinizden emin misiniz?</p>
            <div className="confirm-btns">
              <button className="cancel-btn" onClick={() => setDeleteModal({ show: false, id: null })}>Vazgeç</button>
              <button className="confirm-delete-btn" onClick={handleDelete}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      <form className="upload-section custom-form" onSubmit={handleAdd}>
        <div className="form-grid">
          <div className="input-group full">
            <label>Duyuru Kapak Görseli</label>
            <div className="file-input-wrapper">
              <Upload size={24} className="upload-icon" />
              <input type="file" id="ann-file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
              <label htmlFor="ann-file">{file ? file.name : "Görsel Seçin veya Sürükleyin"}</label>
            </div>
          </div>
          <div className="input-group full">
            <label>Duyuru Başlığı</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Duyuru başlığını giriniz..." />
          </div>
          <div className="input-group full">
            <label>Duyuru Detayı</label>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Duyuru içeriğini buraya yazınız..." />
          </div>
        </div>
        <button type="submit" className="upload-confirm-btn" disabled={uploading}>
          {uploading ? <div className="spinner-small"></div> : "Duyuruyu Yayınla"}
        </button>
      </form>

      <div className="divider"><span>Aktif Duyurular</span></div>
      
      <div className="slider-preview-grid">
        {announcements.map((ann) => (
          <div key={ann.id} className="preview-card-full">
            <img src={ann.imageUrl} alt={ann.title} style={{height: '180px', objectFit: 'cover'}} />
            <div className="card-details">
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                <span style={{fontSize: '0.7rem', color: '#2ecc71', fontWeight: '800'}}>{ann.date}</span>
                <button onClick={() => setDeleteModal({show: true, id: ann.id})} className="delete-btn-simple" style={{padding: '5px'}}>
                  <Trash2 size={14}/>
                </button>
              </div>
              <h4>{ann.title}</h4>
              <p>{ann.content.substring(0, 100)}...</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementManager;